export enum SettingsCardType {
	AgentTemplates = 'agentTemplates',
	Blitzes = 'blitzes',
	CallAnalysis = 'callAnalysis',
	Categories = 'categories',
	DashAndReports = 'dashAndReports',
	EmailSignature = 'emailSignature',
	EmailTemplates = 'emailTemplates',
	Gamification = 'gamification',
	Goals = 'goals',
	ManageUsers = 'manageUsers',
	Password = 'password',
	PhoneNumbers = 'phoneNumbers',
	PrizesLog = 'prizesLog',
	ScenarioManagement = 'scenarioManagement',
	ScenarioProgress = 'scenarioProgress',
	SlotMachinePrizes = 'slotMachinePrizes',
	SlotMachines = 'slotMachines',
	StartABlitz = 'startABlitz',
	Utilities = 'utilities',
	Voicemail = 'voicemail',
}

export interface ISettingsCard {
	href?: string; // external link
	settingType: SettingsCardType;
	text: string;
	to?: string; // internal link
}

export const AdminSettingsCards: ISettingsCard[] = [
	{
		settingType: SettingsCardType.Gamification,
		text: 'Gamification',
	},
	{
		settingType: SettingsCardType.Blitzes,
		text: 'Blitzes',
	},
	{
		settingType: SettingsCardType.DashAndReports,
		text: 'Dash & Reports',
	},
	{
		settingType: SettingsCardType.PrizesLog,
		text: 'Prizes Log',
	},
	{
		settingType: SettingsCardType.SlotMachines,
		text: 'Slot Machines',
	},
	{
		settingType: SettingsCardType.SlotMachinePrizes,
		text: 'Slot Machine Prizes',
		to: '/slotmachine/prizes',
	},
	{
		settingType: SettingsCardType.AgentTemplates,
		text: 'Sales AI Agents',
	},
	{
		settingType: SettingsCardType.CallAnalysis,
		text: 'Call Analysis',
	},
	{
		settingType: SettingsCardType.Goals,
		text: 'Goals',
	},
	{
		settingType: SettingsCardType.ScenarioManagement,
		text: 'Scenario Management',
	},
	{
		settingType: SettingsCardType.ScenarioProgress,
		text: 'Training Progress',
	},
	{
		settingType: SettingsCardType.Utilities,
		text: 'Utilities',
	},
	{
		settingType: SettingsCardType.PhoneNumbers,
		text: 'Phone Numbers',
	},
	{
		settingType: SettingsCardType.Categories,
		text: 'Categories',
	},
	{
		settingType: SettingsCardType.Voicemail,
		text: 'Voicemail',
		to: '/user/voicemail',
	},
	{
		href: `${import.meta.env.VITE_APP_URL}/#/templates`,
		settingType: SettingsCardType.EmailTemplates,
		text: 'Email Templates',
	},
	{
		href: `${import.meta.env.VITE_APP_URL}/#/settings/admin/manage-users`,
		settingType: SettingsCardType.ManageUsers,
		text: 'Manage Users',
	},
].filter(s => (import.meta.env.PROD && s.settingType === SettingsCardType.SlotMachinePrizes ? false : true));

export const UserSettingsCards: ISettingsCard[] = [
	{
		href: `${import.meta.env.VITE_APP_URL}/#/settings/password`,
		settingType: SettingsCardType.Password,
		text: 'Password',
	},
	{
		settingType: SettingsCardType.Voicemail,
		text: 'Voicemail',
		to: '/user/voicemail',
	},
	{
		settingType: SettingsCardType.CallAnalysis,
		text: 'Call Analysis',
	},
	{
		settingType: SettingsCardType.ScenarioProgress,
		text: 'Training Progress',
	},
	{
		settingType: SettingsCardType.SlotMachinePrizes,
		text: 'Slot Machine Prizes',
		to: '/slotmachine/prizes',
	},
	{
		href: `${import.meta.env.VITE_APP_URL}/#/settings/email-signature`,
		settingType: SettingsCardType.EmailSignature,
		text: 'Signature',
	},
];
